import { useTranslation } from 'react-i18next'

export function Resources() {
  const { t } = useTranslation()

  return (
    <section className='flex flex-col gap-10 px-6 md:px-20 py-25 bg-gray-100 text-center text-xl md:text-2xl leading-relaxed opacity-90 items-center'>
      <h3 className='text-4xl md:text-5xl font-medium'>{t('resources.title')}</h3>
      <div className='space-y-3 max-w-4xl mx-auto'>
        <strong className='block text-2xl'>{t('resources.linkLibraryTitle')}</strong>
        <p>{t('resources.linkLibraryDesc')}</p>
        <a
          href='https://linktr.ee/Kherson_Human_Safari'
          target='_blank'
          rel='noopener noreferrer'
          className='underline text-blue-600 break-all'
        >
          https://linktr.ee/Kherson_Human_Safari
        </a>
      </div>
      <div className='space-y-3 max-w-4xl mx-auto'>
        <strong className='block text-2xl'>{t('resources.truthHoundsTitle')}</strong>
        <a
          href='https://truth-hounds.org/en/cases/killzone-how-russian-drones-are-devastating-the-river-dnipros-right-bank/'
          target='_blank'
          rel='noopener noreferrer'
          className='underline text-blue-600 break-all'
        >
          {t('resources.truthHoundsDesc')}
        </a>
      </div>
      <div className='space-y-3 max-w-4xl mx-auto'>
        <strong className='block text-2xl'>{t('resources.hrwTitle')}</strong>
        <a
          href='https://www.hrw.org/report/2025/06/03/hunted-from-above/russias-use-of-drones-to-attack-civilians-in-kherson-ukraine'
          target='_blank'
          rel='noopener noreferrer'
          className='underline text-blue-600'
        >
          {t('resources.hrwDesc')}
        </a>
      </div>

      <div className='space-y-3 max-w-4xl mx-auto'>
        <strong className='block text-2xl'>{t('resources.unReportsTitle')}</strong>
        <a
          href='https://www.ohchr.org/sites/default/files/documents/hrbodies/hrcouncil/coiukraine/a-hrc-59-crp2-en.pdf'
          target='_blank'
          rel='noopener noreferrer'
          className='underline text-blue-600 block'
        >
          {t('resources.report1')}
        </a>
        <a
          href='https://www.ohchr.org/en/hr-bodies/hrc/iicihr-ukraine/reports/report-independent-international-commission-inquiry-ukraine-un-general-assembly-a80497'
          target='_blank'
          rel='noopener noreferrer'
          className='underline text-blue-600 block'
        >
          {t('resources.report3')}
        </a>
        <a
          href='https://www.ohchr.org/sites/default/files/documents/hrbodies/hrcouncil/coiukraine/a-80-497-advance-unedited-version-en.pdf'
          target='_blank'
          rel='noopener noreferrer'
          className='underline text-blue-600'
        >
          {t('resources.guidelines')}
        </a>
      </div>

      <div className='space-y-3 max-w-4xl mx-auto'>
        <strong className='block text-2xl'>{t('resources.wikipediaTitle')}</strong>
        <a
          href='https://en.wikipedia.org/wiki/Human_safari_(terror_campaign)'
          target='_blank'
          rel='noopener noreferrer'
          className='underline text-blue-600 block'
        >
          {t('resources.english')}
        </a>
      </div>

      <div className='space-y-3 max-w-4xl mx-auto'>
        <strong className='block text-2xl'>{t('resources.documentaryTitle')}</strong>
        <a
          href='https://www.khersonhumansafari.com'
          target='_blank'
          rel='noopener noreferrer'
          className='underline text-blue-600'
        >
          www.khersonhumansafari.com
        </a>
      </div>
    </section>
  )
}
